import React, { useState, useEffect } from 'react';
import API from '../Api';
import { useNavigate } from 'react-router-dom';
import SubPageHeader from '../../components/common/SubPageHeader';

// Image Imports
import image1 from '../../assets/images/IMG_2430.jpg';
import image2 from '../../assets/images/Workshop.JPG';
import image3 from '../../assets/images/Workshop1.JPG';
import image4 from '../../assets/images/workshop3.JPG';
import image5 from '../../assets/images/Farming.jpg';
import image6 from '../../assets/images/Farming2.jpg';

const DawadiCenter = () => {
  const [content, setContent] = useState({});
  const navigate = useNavigate();


  const defaultSections = [
    { title: "The Vision 2020", text: "We had started the year 2020 with our slogan- 'MISSION2022-THE BEST YEAR OF MY LIFE'. We conducted a series of sessions from December end to February end with this slogan. The year 2020 started with resolutions and action plans with full zeal and exuberance.", img: image1, color: "bg-blue-50" },
    { title: "The Sudden Halt", text: "But destiny had something else stored for us. The covid19 virus spread its arms bringing the world to a sudden stop. TGSOH plans to reach out students, planned workshops and seminars had to be postponed with uncertainty.", img: image2, color: "bg-white" },
    { title: "Positive Resilience", text: "The HAPPINESS AMBASSADORS always think positive in any critical situation to make the best out of that circumstances. Amidst a confused atmosphere, curfew and everything at a standstill we decided to review the entire situation to do our best & make 2020 the best year of our lives.", img: image3, color: "bg-blue-50" },
    { title: "Finding Serenity", text: "This led to us to the serene, pleasant atmosphere where covid had not entered & that was the village DAWADI at Khed taluka in Pune district. Visits continued and the decision to build a centre was finalised.", img: image4, color: "bg-white" },
    { title: "Birth of RAMDHAM", text: "We started the project in September 2020 with insufficient funds and lack of resources as this is a rural destination. But, when going gets tough-tough gets going! With perseverance, tremendous will power and consistency we were able to complete the first centre vastu -'RAMDHAM' in march 2021.", img: image5, color: "bg-blue-50" },
    { title: "Gratitude & Blessings", text: "100% credit to the land owner and the major financer Mr.Rambhau Satpute- the first fauji (army personnel) of the village for his endless motivation to build this centre. The vastu was blessed with the couple Mr. Rambhau and his better half Kamal performing kalash poojan on the auspicious occasion of GUDI PADWA 2021.", img: image6, color: "bg-white" }
  ];

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await API.get('get-content/Dawadi Center/');
        setContent(res.data);
      } catch (err) { console.error("Error fetching Dawadi content:", err); }
    };
    fetchContent();
  }, []);

  const resolveImageUrl = (apiImg, defaultImg) => {
    if (!apiImg) return defaultImg;
    return apiImg.startsWith('http') ? apiImg : `${process.env.REACT_APP_BACKEND_URL || 'http://103.172.92.148:8005'}${apiImg}`;
  };

  return (
    <div className="min-h-screen bg-gray-50 overflow-x-hidden">
      <SubPageHeader title="DAWADI CENTER" />

      <div className="relative">
        {/* Background Decorative Elements */}
        <div className="absolute top-20 left-0 w-64 h-64 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
        <div className="absolute top-40 right-0 w-72 h-72 bg-green-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>

        <div className="relative space-y-0">
          {defaultSections.map((item, index) => {
            
            const title = content[`dawadi_${index + 1}_title`] || item.title;
            const text = content[`dawadi_${index + 1}_text`] || item.text;
            const img = resolveImageUrl(content[`dawadi_${index + 1}_img`], item.img);

            return (
              <section 
                key={index} 
                className={`py-10 md:py-16 lg:py-24 ${item.color}`}
                // data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
              >
                <div className="container mx-auto px-6 md:px-12 lg:px-20">
                  <div className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-8 md:gap-12 lg:gap-16`}>
                    
                    {/* Content Box */}
                    <div className="flex-1 space-y-6">
                      <div className="inline-block px-4 py-1 rounded-full bg-blue-100 text-[#003366] text-sm font-bold tracking-widest uppercase">
                        Step 0{index + 1}
                      </div>
                      <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#003366]">
                        {title}
                      </h2>
                      <p className="text-lg text-gray-700 leading-relaxed text-justify md:text-left">
                        {text}
                      </p>
                      <div className="w-20 h-1 bg-[#54a50f] rounded-full"></div>
                    </div>

                    {/* Image Box with 3D Effect */}
                    <div className="flex-1 w-full group">
                      <div className="relative perspective-1000">
                        <div className="absolute -inset-4 bg-gradient-to-tr from-[#003366] to-[#54a50f] rounded-[2rem] blur opacity-20 group-hover:opacity-40 transition duration-500"></div>
                        <div className="relative overflow-hidden rounded-[1.5rem] md:rounded-[2rem] shadow-2xl bg-white p-2 md:p-3  transition duration-500 group-hover:rotate-2">
                          <img
                            src={img}
                            alt={title}
                            className="
                              w-full
                              h-auto
                              md:h-[400px]
                              object-contain
                              md:object-cover
                              rounded-[1.5rem]
                              cursor-pointer
                              hover:scale-105
                              transition-transform
                              duration-700
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Final Section Special Layout */}
                  {index === 5 && (
                    <div className="mt-24 p-8 md:p-16 bg-[#003366] rounded-[3rem] text-white shadow-2xl relative overflow-hidden">
                      <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16"></div>
                      <div className="relative z-10 grid md:grid-cols-2 gap-10 items-center">
                        <div className="space-y-4">
                          <h3 className="text-2xl font-bold italic">Facilities & Schedule</h3>
                          <p className="opacity-90 leading-relaxed text-lg">
                            500 sq ft hall, master bedrooms, 6 acres of meditation retreat land. Early morning Yoga, Pranayama, and night sky gazing from our huge terrace.
                          </p>
                        </div>
                        <div className="text-center">
                          <p className="text-2xl font-black mb-8 tracking-tighter">
                            READY TO JOIN THE HAPPINESS FAMILY?
                          </p>
                          <button 
                            type="button" 
                            onClick={() => navigate('/TGSH/register')} 
                            className="bg-[#54a50f] hover:bg-[#032167] text-white font-bold py-4 px-12 rounded-full transition-all duration-300 ease-in-out shadow-lg hover:shadow-2xl transform hover:scale-105 active:scale-95 text-lg tracking-wide"
                          >
                           Join A Course Now !!!
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </section>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DawadiCenter;